import { DSTextInput } from '@vr/ds-react'
import { Controller } from 'react-hook-form'

import { IGroupingProps } from './interface'

const Grouping = ({ control, accountKey }: IGroupingProps) => {
  return (
    <Controller
      key={accountKey}
      name='agrupamento'
      control={control}
      render={({ field: { onChange, value } }) => (
        <DSTextInput
          value={value}
          onChange={onChange}
          placeholder='Busque pelo número'
          label='Agrupamento'
        />
      )}
    />
  )
}

export default Grouping
